var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPerspective(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 5.00004C9 4.44775 9.44772 4.00004 10 4.00004C10.5523 4.00004 11 4.44775 11 5.00004L11 11H14L14 7.00004C14 6.44775 14.4477 6.00004 15 6.00004C15.5523 6.00004 16 6.44775 16 7.00004V11L20 11C20.5523 11 21 11.4478 21 12C21 12.5523 20.5523 13 20 13L16 13V17C16 17.5523 15.5523 18 15 18C14.4477 18 14 17.5523 14 17V13L11 13V19C11 19.5523 10.5523 20 10 20C9.44772 20 9 19.5523 9 19L9 13L4 13C3.44772 13 3 12.5523 3 12C3 11.4478 3.44772 11 4 11L9 11V5.00004Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 5.98483C3 4.06966 4.77016 2.64486 6.64109 3.05413L18.6411 5.67913C20.0183 5.9804 21 7.20001 21 8.60983L21 15.3902C21 16.8001 20.0183 18.0197 18.6411 18.3209L6.64109 20.9459C4.77016 21.3552 3 19.9304 3 18.0152L3 5.98483ZM6.2137 5.00793C5.59005 4.87151 5 5.34644 5 5.98483L5 18.0152C5 18.6536 5.59005 19.1286 6.2137 18.9921L18.2137 16.3671C18.6728 16.2667 19 15.8602 19 15.3902L19 8.60983C19 8.13989 18.6728 7.73335 18.2137 7.63293L6.2137 5.00793Z",
    fill: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 23.4291,
    y1: 26.6517,
    x2: 9.64924,
    y2: -1.15669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0965F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31D8BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 23.4291,
    y1: 26.6517,
    x2: 9.64924,
    y2: -1.15669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0965F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31D8BF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerspective);
export default __webpack_public_path__ + "static/media/perspective.c8fb26e56b77bf1dbefd00035d904836.svg";
export { ForwardRef as ReactComponent };